{
	"name": "jsrepo",
	"description": "A CLI to add shared code from remote repositories.",
	"version": "2.4.1",
	"license": "MIT",
	"homepage": "https://jsrepo.dev",
	"author": {
		"name": "Aidan Bleser",
		"url": "https://github.com/ieedan"
	},
	"repository": {
		"type": "git",
		"url": "git+https://github.com/jsrepojs/jsrepo"
	},
	"bugs": {
		"url": "https://github.com/jsrepojs/jsrepo/issues"
	},
	"keywords": ["repo", "cli", "svelte", "vue", "typescript", "javascript", "shadcn", "registry"],
	"type": "module",
	"packageManager": "pnpm@10.8.1",
	"exports": {
		".": {
			"types": "./dist/api/index.d.ts",
			"default": "./dist/api/index.js"
		}
	},
	"bin": "./dist/index.js",
	"main": "./dist/index.js",
	"files": ["./schemas/**/*", "dist/**/*"],
	"scripts": {
		"start": "tsup --silent && node ./dist/index.js",
		"build": "tsup",
		"generate:reference": "pnpm dlx tsx ./scripts/generate-reference.ts ",
		"run:dev": "node ./dist/index.js",
		"format": "biome format --write",
		"lint": "biome lint --write",
		"check": "biome check && pnpm check:types",
		"test": "vitest",
		"check:types": "tsc",
		"changeset:version": "changeset version && pnpm generate:reference && pnpm format",
		"ci:release": "pnpm build && changeset publish",
		"mcp:inspector": "pnpm build && pnpm dlx @modelcontextprotocol/inspector node ./dist/index.js mcp"
	},
	"devDependencies": {
		"@biomejs/biome": "1.9.4",
		"@changesets/cli": "^2.29.4",
		"@types/make-fetch-happen": "^10.0.4",
		"@types/node": "^22.15.24",
		"@types/semver": "^7.7.0",
		"@types/validate-npm-package-name": "^4.0.2",
		"pkg-pr-new": "^0.0.51",
		"tsup": "^8.5.0",
		"typescript": "^5.8.3",
		"vitest": "^3.1.4"
	},
	"dependencies": {
		"@anthropic-ai/sdk": "^0.52.0",
		"@biomejs/js-api": "^0.7.1",
		"@biomejs/wasm-nodejs": "^1.9.4",
		"@clack/prompts": "^0.11.0",
		"@modelcontextprotocol/sdk": "^1.12.0",
		"boxen": "^8.0.1",
		"chalk": "^5.4.1",
		"commander": "^14.0.0",
		"conf": "^13.1.0",
		"css-dependency": "^0.0.3",
		"diff": "^8.0.2",
		"escape-string-regexp": "^5.0.0",
		"estree-walker": "^3.0.3",
		"get-tsconfig": "^4.10.1",
		"ignore": "^7.0.4",
		"is-unicode-supported": "^2.1.0",
		"make-fetch-happen": "^14.0.3",
		"node-machine-id": "^1.1.12",
		"ollama": "^0.5.14",
		"openai": "^4.103.0",
		"oxc-parser": "^0.72.1",
		"package-manager-detector": "^1.3.0",
		"parse5": "^7.3.0",
		"pathe": "^2.0.3",
		"prettier": "^3.5.3",
		"semver": "^7.7.2",
		"sisteransi": "^1.0.5",
		"svelte": "^5.33.6",
		"tar": "^7.4.3",
		"tinyexec": "^1.0.1",
		"valibot": "1.1.0",
		"validate-npm-package-name": "^6.0.0",
		"vue": "^3.5.16"
	}
}
